<template>
  <div class="w-100">
    <v-stepper
      elevation="0"
      style="box-shadow: 0 !important"
      class="rtl-stepper"
      v-model="e1"
    >
      <v-stepper-header elevation="0" direction="rtl">
        <v-stepper-step step="1">انتخاب فضا</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="2">تعرفه‌ها</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3">انتخاب درگاه</v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="1">
          <v-card elevation="0">
            <v-card-text>
              <v-card-title> لیست فضاهای تبلیغاتی جهت رزرو : </v-card-title>
            </v-card-text>
            <v-card-item>
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                  v-for="(item, i) in selectSpace.items"
                  :key="i"
                >
                  <v-card rounded="xl" elevation="2">
                    <v-card-item class="w-100">
                      <v-img
                        style="
                          border-top-right-radius: 15px;
                          border-top-left-radius: 15px;
                        "
                        :src="
                          item?.image?.length > 0
                            ? item.image
                            : 'https://www.bahmansport.com/media/com_store/images/empty.png'
                        "
                      />
                    </v-card-item>
                    <v-card-title>{{ item.name }}</v-card-title>

                    <v-card-actions>
                      <v-btn
                        style="
                          border-bottom-left-radius: 15px;
                          border-bottom-right-radius: 15px;
                        "
                        color="primary"
                        class="w-100"
                        outlined
                        @click="
                          selectSpaceItem = item;
                          e1 = 2;
                        "
                      >
                        <v-icon>mdi-view-grid-outline</v-icon>
                        مشاهده تعرفه ها
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-item>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="2">
          <v-card v-if="selectSpaceItem.active" elevation="0" class="w-100">
            <v-list-item two-line>
              <v-card-title
                >برای رزرو بنر تبلیغاتی تاریخ شروع و اتمام راوارد
                کنید</v-card-title
              >
            </v-list-item>

            <v-row class="w-100 pa-2">
              <!-- <v-col cols="12" md="6">
                <date-picker
                  v-model="selectInformationGate.start_time"
                  clearable
                  display-format="jYYYY-jMM-jDD"
                  format="YYYY-MM-DD"
                  label="از تاریخ"
                />
              </v-col>
              <v-col cols="12" md="6">
                <date-picker
                  v-model="selectInformationGate.end_time"
                  clearable
                  display-format="jYYYY-jMM-jDD"
                  format="YYYY-MM-DD"
                  label="تا تاریخ"
                />
              </v-col> -->
            </v-row>

            <v-divider></v-divider>

            <v-card-actions class="d-flex justify-content-between">
              <v-btn @click="e1 = 1" outlined color="red">
                <v-icon>mdi-chevron-right</v-icon>
                بازگشت
              </v-btn>
              <v-btn @click="reserveDay" class="" color="green" outlined>
                رزرو بنر
                <v-icon>mdi-content-save-check</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-card
            v-else
            class="w-100 d-flex flex-column justify-content-center"
          >
            <v-card-title>
              در حال حاضر لیستی برای اجاره بنر تبلیغاتی وجود ندارد
            </v-card-title>
            <v-card-actions>
              <v-btn @click="e1 = 1" outlined color="red"> بازگشت </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="3">
          <div class="pa-2">
            <v-card elevation="2" rounded="xl">
              <v-card-title>
                فضای تبلیغاتی انتخاب شده :
                {{ selectSpace?.name }} - {{ selectSpaceItem?.name }} -
                {{ getPersianDate(selectInformationGate.start_time) }} الی
                {{ getPersianDate(selectInformationGate.end_time) }} -
                {{
                  lengthTima(
                    selectInformationGate.start_time,
                    selectInformationGate.end_time
                  )
                }}روزه
              </v-card-title>
              <v-card-subtitle> مبلغ قابل پرداخت : 1000ریال </v-card-subtitle>
            </v-card>
          </div>
          <select-gate-slaes v-model="selectInformationGate.gate" />
          <div class="w-100 d-flex justify-content-between">
            <v-btn @click="e1 = 2" outlined color="red">
              <v-icon>mdi-chevron-right</v-icon>
              بازگشت
            </v-btn>
            <v-btn outlined class="mx-2" color="green">
              پرداخت
              <v-icon>mdi-credit-card-multiple</v-icon>
            </v-btn>
          </div>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import selectGateSlaes from "./selectGateSlaes.vue";
export default {
  components: { selectGateSlaes },
  name: "selectGateSpace",
  props: { value: Object },

  data() {
    return {
      e1: 1,
      //   select z space item
      selectSpaceItem: {
        gate: {},
        start_time: "",
        end_time: "",
      },
      time: 0,
      payLabels: ["روزانه", "هفتگی", "ماهانه", "سه ماهه", "شش ماهه", "یک ساله"],
      //   sellect gate pay
      selectInformationGate: {
        gate: {},
        start_time: "",
        end_time: "",
      },
      //   save all information for pay
    };
  },
  watch: {
    time: {
      immediate: true,
      deep: true,
      handler(val) {
        this.selectInformationGate = {
          gate: {},
          start_time: "",
          end_time: "",
        };
      },
    },
    value: {
      deep: true,
      handler(val) {
        if (Object.keys(val).length === 0) {
          this.e1 = 1;
          this.time = 0;
          this.selectSpaceItem = {};
          this.selectInformationGate = {
            gate: {},
            start_time: "",
            end_time: "",
          };
        }
      },
    },
  },

  methods: {
    reserveDay() {
      if (
        this.selectInformationGate.start_time.length > 0 &&
        this.selectInformationGate.end_time.length > 0
      ) {
        this.e1 = 3;
      } else {
        this.$toast.error("تاریخ شروع و پایان نمیتواند خالی باشد");
      }
    },
    getPersianDate(dateString) {
      const date = new Date(dateString);
      if (isNaN(date)) return "تاریخ نامعتبر";
      const formatter = new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
      return formatter.format(date);
    },
    lengthTima(start_time, end_end) {
      const start = new Date(start_time);
      const end = new Date(end_end);

      const diffInMs = end - start; // فاصله به میلی‌ثانیه
      const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

      return diffInDays.toString().replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);
    },
  },

  computed: {
    selectSpace: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style scoped>
.rtl-stepper {
  direction: rtl;
  box-shadow: none !important;
}

.v-stepper >>> .v-stepper__header {
  justify-content: flex-end; /* میاره مراحل سمت راست */
  box-shadow: none !important;
}

.rtl-stepper .v-stepper__step {
  text-align: right; /* متن مرحله راست‌چین */
}
</style>
